import { Component } from '@angular/core';

@Component({
  selector: 'forbidden-page',
  templateUrl: './forbidden.component.html',
})
export class ForbiddenComponent {
  constructor() {}
}
